export default __webpack_public_path__ + "static/media/Thumb_Accessories_03.bbbcade2.png";